import * as React from 'react';

import { FetchMethod } from '@common/react/components/UI/LoadingButton/LoadingButton';
import { DownloadFileButton } from '@common/react/components/UI/DownloadFileButton/DownloadFileButton';

import { Appointment, SystemAppointmentStatus } from '@app/objects/Appointment';
import { Links } from '@app/components/UI/Links/Links';

interface Props {
	appointment: Appointment;
	onError?: (err: string) => void;
	className?: string;
	style?: React.CSSProperties;
}

export const WizardButton: React.FC<Props> = ({
	appointment,
	onError,
	className = 'btn btn-sm btn-primary mr5',
	style = { width: 34 },
}) => {
	return appointment.status?.saStatus !== SystemAppointmentStatus.Closed
		? (
			<Links.Wizard
				id={appointment.id}
				title="Start Appointment"
				className={className}
				style={style}
			>
				<i className="fa fa-rocket" />
			</Links.Wizard>
		)
		: (
			<DownloadFileButton
				title="Download Medical Note Caption"
				className={className}
				method={FetchMethod.GET}
				path={`/wizardPdf?appointmentId=${appointment.id}`}
				onError={onError}
			>
				<i className="fa fa-download" />
			</DownloadFileButton>
		);
};
